module.exports = __webpack_public_path__ + "img/wigo-logo-white.fad50668.png";